const CACHE_PREFIX = "wordscape:word-quiz:v2:";

function getCacheKey(word, context, occurrenceId) {
  return `${CACHE_PREFIX}${JSON.stringify([
    occurrenceId,
    word.trim().toLowerCase(),
    context.trim(),
  ])}`;
}

function isNonEmptyString(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function isValidQuizData(value) {
  if (
    !value ||
    typeof value !== "object" ||
    !isNonEmptyString(value.sentence) ||
    !isNonEmptyString(value.meaning) ||
    !isNonEmptyString(value.tip) ||
    !Array.isArray(value.options) ||
    value.options.length !== 3
  ) {
    return false;
  }

  const validOptions = value.options.every(
    (option) =>
      option &&
      typeof option === "object" &&
      isNonEmptyString(option.meaning) &&
      typeof option.isCorrect === "boolean",
  );
  const correctOptionCount = value.options.filter(
    (option) => option?.isCorrect,
  ).length;

  return validOptions && correctOptionCount === 1;
}

export function readCachedWordQuiz(word, context, occurrenceId) {
  if (typeof window === "undefined" || !occurrenceId) return null;

  try {
    const storage = window.localStorage;
    const key = getCacheKey(word, context, occurrenceId);
    const serialized = storage.getItem(key);
    if (!serialized) return null;

    const data = JSON.parse(serialized);
    if (isValidQuizData(data)) return data;

    storage.removeItem(key);
  } catch {
    return null;
  }

  return null;
}

export function cacheWordQuiz(word, context, occurrenceId, data) {
  if (
    typeof window === "undefined" ||
    !occurrenceId ||
    !isValidQuizData(data)
  ) {
    return;
  }

  try {
    window.localStorage.setItem(
      getCacheKey(word, context, occurrenceId),
      JSON.stringify(data),
    );
  } catch {
    // Quiz generation still works when storage is unavailable or full.
  }
}
